import { render, staticRenderFns } from "./InviteesTable.vue?vue&type=template&id=35991d70&scoped=true"
import script from "./InviteesTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./InviteesTable.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./InviteesTable.vue?vue&type=style&index=0&id=35991d70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35991d70",
  null
  
)

export default component.exports